import { z } from 'zod'

import { parseOptionalPhoneNumber } from './phoneValidation'

const requiredEmailSchema = z.string().trim().min(1, 'E-post er påkrevd').email('Ugyldig e-postadresse')

const optionalPhoneSchema = z.string().transform((value, ctx) => {
    const result = parseOptionalPhoneNumber(value)
    if (!result.ok) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Ugyldig telefonnummer',
        })
        return z.NEVER
    }

    return result.normalized
})

export const feedbackFormSchema = z.object({
    subject: z.string().trim().min(1, 'Tittel er påkrevd'),
    description: z.string().trim().min(1, 'Beskrivelse er påkrevd'),
    email: requiredEmailSchema,
    phone: optionalPhoneSchema,
})

export type SupportFeedbackFormParsedValues = z.infer<typeof feedbackFormSchema>
